<template>
  <div class="container">
     <router-view></router-view>
  </div>
  

</template>

<script>
import "@/utils/resize"
export default {
  name: 'App',
  components: {
  }
}
</script>

<style>
@import '../static/reset.css';
@import '../static/color.css';
#app{
  width: 100%;
  height: 100%;
  overflow-x: hidden;
}
</style>
